export const s3Config = {
  bucketName:  process.env.REACT_APP_BUCKET_NAME || "",
  dirName: process.env.REACT_APP_DIRECTORY_NAME || "",      /* Optional */
  region: process.env.REACT_APP_REGION || "",
  accessKeyId: process.env.REACT_APP_ACCESS_KEY || "",
  secretAccessKey: process.env.REACT_APP_SECRET || "",
  s3Url: process.env.REACT_APP_BUCKET_URL || ""
};
